import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PatientDetailsLayoutProps } from './types';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: theme.palette.common.white,
  },
}));


export function PhonePortraitLayout(props: PatientDetailsLayoutProps) {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      {props.patientDetails}
      {props.patientAccordions}
    </Box>
  );
}
